import { render, staticRenderFns } from "./FallaCombinedParts.vue?vue&type=template&id=38031761&scoped=true"
import script from "./FallaCombinedParts.vue?vue&type=script&lang=js"
export * from "./FallaCombinedParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38031761",
  null
  
)

export default component.exports